export function daysInMonth(month) {
	// get the number of day in a  month
	// current year
	const year = new Date().getFullYear();
	return new Date(year, month, 0).getDate();
}
